export type SystemTypeCode = EntityTypeCode | ObjectTypeCode;
export type SystemTypeName = EntityTypeName | ObjectTypeName;

export enum EntityTypeCode {
  // be sure to add a record in SystemTypeHelpers
  Claimant = 'CL',
  Employer = 'ER',
  Insurer = 'IN',
  HealthcareProvider = 'HP',
  HealthcareProviderLicense = 'HL',
  MedicalSupplier = 'MS',
  ThirdPartyAdministrator = 'TP',
  UtilizationReviewer = 'UR',
  PharmacyBenefitManager = 'PB',
}

export enum EntityTypeName {
  // be sure to add a record in SystemTypeHelpers
  Claimant = 'Claimant',
  Employer = 'Employer',
  Insurer = 'Insurer',
  HealthcareProvider = 'HealthcareProvider',
  HealthcareProviderLicense = 'HealthcareProviderLicense',
  MedicalSupplier = 'MedicalSupplier',
  ThirdPartyAdministrator = 'ThirdPartyAdministrator',
  UtilizationReviewer = 'UtilizationReviewer',
  PharmacyBenefitManager = 'PharmacyBenefitManager',
}

export enum ObjectTypeCode {
  // be sure to add a record in SystemTypeHelpers
  MedicalBillingDispute = 'UB',
  Document = 'DO',
  PriorAuthorization = 'PA',
  Level1InsurerReview = 'L1',
  Level2InsurerReview = 'L2',
  MdoReviewRequest = 'MR',
}

export enum ObjectTypeName {
  // be sure to add a record in SystemTypeHelpers
  MedicalBillingDispute = 'Medical Billing Dispute',
  Document = 'Document',
  PriorAuthorization = 'Prior Authorization',
  Level1InsurerReview = 'Level 1 PAR Insurer Review',
  Level2InsurerReview = 'Level 2 PAR Insurer Review',
  MdoReviewRequest = 'Medical Directors Office Review Request',

  // NWC-35646: Display only (Update Status modal). Other areas depend on the name w/o punctuation.
  // Do not use if the value will be used for anything other than display
  MdoReviewRequestPunctuated = "Medical Director's Office Review Request",
}

export enum ObjectSubTypeEnum {
  MedicationPriorAuth = 1,
  DurableMedicalEquipmentPriorAuth = 2,
  ConfirmationPriorAuth = 3,
  NonMtgOver1000PriorAuth = 4,
  NonMtgUnder1000PriorAuth = 5,
  SpecialServicesPriorAuth = 6,
  VariancePriorAuth = 7,
}
